import { Templates } from '@/types/common';
import { Modal } from '../Common/Modal';
import { isMobileDevice } from '@/utils/device';
import { hasPublisherHaveBackgroundImage } from '@/utils/publisher';
import type { CheckoutTheme } from '@/types/boot';
import { useGetBoot } from '@/hooks/useGetBoot';
import { useTemplate } from '@/hooks/useTemplate';
import TopWrapperSkeleton from './TopWrapperSkeleton';
import PaymentSkeleton from './PaymentSkeleton';
import OnePaymentSkeletonLoader from './OnePaymentSkeletonLoader';
import { CheckoutTemplate } from '@/types/boot';

const CheckoutSkeletonLoader = () => {
  const bootData = useGetBoot();
  const templateHook = useTemplate();
  const templateType = bootData.boot?.checkoutConfiguration?.template ?? null;
  const hasBackgroundImage = hasPublisherHaveBackgroundImage(
    bootData.boot?.checkoutTheme as CheckoutTheme,
    templateHook.template.type as Templates
  );
  const backgroundImage = hasBackgroundImage
    ? isMobileDevice()
      ? bootData.boot?.checkoutTheme?.mobileBgImage || bootData.boot?.checkoutTheme?.backgroundImage
      : bootData.boot?.checkoutTheme?.backgroundImage
    : undefined;

  if (templateType === CheckoutTemplate.SINGLE_PAYMENT_METHOD) {
    return <OnePaymentSkeletonLoader />;
  }

  return (
    <Modal>
      <div className="flex flex-col sm:justify-center md:flex-row md:justify-start md:h-full overflow-y-auto md:overflow-y-hidden bg-white landscape:flex-row landscape:h-[100dvh] landscape:overflow-y-hidden landscape:overflow-x-hidden">
        <div
          className="flex flex-col items-center py-4 justify-center md:w-2/5 md:justify-start bg-cover bg-center bg-top md:h-full landscape:w-2/5 landscape:h-[100dvh] landscape:justify-start"
          style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined}
        >
          <TopWrapperSkeleton />
        </div>
        <div className="relative flex flex-col items-center py-4 md:w-3/5 md:h-full md:overflow-y-auto landscape:w-3/5 landscape:h-[100dvh] landscape:overflow-y-auto">
          <div className="flex w-full justify-center items-center h-full">
            <PaymentSkeleton />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CheckoutSkeletonLoader;
